/** React Query keys for one monetization read model, so refresh invalidates every view of it. */
export const monetizationQueryKeys = {
  summary: (experimentId: string) =>
    ["monetization-summary", experimentId] as const,
  assignments: (experimentId: string) =>
    ["monetization-assignments", experimentId] as const,
  board: (experimentId: string) =>
    ["monetization-journey-board", experimentId] as const,
};
